import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

/** Published address, used for links in emails when the request host cannot be trusted. Update it if the free subdomain changes. */
export const PUBLIC_SITE_URL = 'https://klinik-sehat-budi-luhur.modulify.website'

export const siteConfig: SiteConfig = {
    name: 'Klinik Pratama Sehat Budi Luhur',
    description: 'Klinik pratama di Leuwigajah, Cimahi. UGD dan persalinan 24 jam, Poli Umum, Poli Gigi, dan KIA/KB untuk pasien umum dan peserta JKN. Buat janji dokter online.',
    url: getOrigin()
}
